var $selectizeElements = $("select[class^='selectize'");

$(document).ready(function () {
  if ($selectizeElements.length) {
    var initialWindowWidth = $(window).width();
    initSelectizeElements($selectizeElements);

    $(window).on("resize", function() {
      if ($(window).width() > initialWindowWidth) {
        initSelectizeElements($selectizeElements);
        initialWindowWidth = $(window).width();
      }
    });
  }
});

function initSelectizeElements(selectizeElements) {
  $(selectizeElements).each(function() {
    var className = $(this).attr('class').split(' ');
    var breakpoint = 1;
    className.forEach(function(cls) {
      if (cls.indexOf("selectize-") >= 0) {
        var screenSize = cls.match("selectize-(.*)")[1];
        breakpoint = breakpoints[screenSize];
      }
    });
  
    if ($(window).width() >= breakpoint) {
      $(this).selectize();
    }
  });
}